import { useSearchParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography'
import KillSwitch from '../KillSwitch'
import StreamCost from './StreamCost'

// One page for what each product spends and the controls that limit it. The
// AI animation tab is the kill switch page as it was; `/kill-switch` lands
// there (`?tab=animation`).
const TABS = [
  { value: 'stream', label: 'Audio streaming' },
  { value: 'animation', label: 'AI animation' },
]

const Cost = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab') === 'animation' ? 'animation' : 'stream'

  return (
    <Box
      sx={{
        px: { mobile: 2, desktop: 6 },
        py: { mobile: 3, desktop: 4 },
        maxWidth: 1600,
        mx: 'auto',
        width: '100%',
      }}
    >
      <Typography variant="h5" fontWeight={700}>
        Cost
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        What each product spends, and the controls that limit it.
      </Typography>
      <Tabs
        value={tab}
        onChange={(event, next) =>
          setSearchParams(next === 'stream' ? {} : { tab: next }, {
            replace: true,
          })
        }
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        {TABS.map(({ value, label }) => (
          <Tab
            key={value}
            value={value}
            label={label}
            sx={{ textTransform: 'none', fontWeight: 500 }}
          />
        ))}
      </Tabs>
      {tab === 'stream' ? <StreamCost /> : <KillSwitch />}
    </Box>
  )
}

export default Cost
